var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOzon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 483.969,
    height: 105.938,
    viewBox: "0 0 483.969 105.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069ff",
    fillRule: "evenodd",
    d: "M58.18.289a52.956 52.956 0 1 0 47.134 47.28A52.89 52.89 0 0 0 58.18.289zm-1.716 80.689A28.247 28.247 0 1 1 80.716 56.65a28.236 28.236 0 0 1-24.252 24.328zm77.174-78.594a12.356 12.356 0 0 0-12.06 14.908c1.162 5.822 6.6 9.8 12.524 9.8h34.378l-53.5 70.8a3.529 3.529 0 0 0 2.8 5.659h83.92c5.92 0 11.362-3.977 12.524-9.8a12.357 12.357 0 0 0-12.055-14.91h-41.887l53.459-70.745a3.562 3.562 0 0 0-2.829-5.712h-77.274zm335.339.285a12.542 12.542 0 0 0-9.639 12.4v41.138L392.679 3.161a3.545 3.545 0 0 0-5.749 2.786v84.941a12.541 12.541 0 0 0 9.639 12.4 12.341 12.341 0 0 0 14.993-12.07V49.724l66.66 53.047a3.544 3.544 0 0 0 5.747-2.785V14.735a12.341 12.341 0 0 0-14.992-12.066zM295.415 24.727c28.195 0 49.262 14.9 49.262 28.228s-21.067 28.228-49.262 28.228-49.262-14.9-49.262-28.228 21.067-28.228 49.262-28.228m0-24.707c-40.811 0-73.894 23.7-73.894 52.935s33.083 52.935 73.894 52.935 73.893-23.7 73.893-52.935S336.225.02 295.415.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzon);
export default __webpack_public_path__ + "static/media/ozon.5ebc45cdb35263503942bfebdddf959c.svg";
export { ForwardRef as ReactComponent };